<template>
  <div class="content">
    <div class="content-select">
      <el-row :gutter="20">
        <el-col :span="4">
          <div class="select-title">
            <div class="title-img">
              <img src="@/assets/appraisal/select-icon.png" alt="" />
            </div>
            <div class="title-info">
              <span>培训项目管理</span>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="content-header">
      <myTableSearch
        :isOperate="true"
        :operateWidth="320"
        :formData="formData"
        :tableLabel="tableLabel"
        :queryFn="queryFn"
        :queryParams="queryParams"
        @successQuery="successQuery"
        :searchColLg="6"
        ref="tableRef"
        dataRow="rows"
      >
        <template slot="openClassTimeList" slot-scope="scope">
          <span class="cell-ellipsis">{{ formatOpenClassTimeList(scope.row) }}</span>
        </template>
        <template slot="status" slot-scope="scope">
          <el-tag v-if="Number(scope.row.status) === 1" type="success" size="small" class="status-tag">在线</el-tag>
          <el-tag v-else-if="Number(scope.row.status) === 2" type="danger" size="small" class="status-tag">下线</el-tag>
          <span v-else>-</span>
        </template>
        <template slot="tool">
          <div class="toolbar-container">
            <div class="toolbar-left">
              <div class="tool-btn" @click="handleRefresh" title="刷新">
                <!-- <img :src="refreshIcon" alt="刷新" class="toolbar-icon"> -->
                <el-button
                  type="primary"
                  icon="el-icon-circle-plus-outline"
                  style="margin-left: 60px"
                  @click="handleAddAppointment"
                  >添加活动</el-button
                >
              </div>
            </div>
            <!-- <div class="toolbar-right">
              <el-button
                plain
                type="info"
                icon="el-icon-fake custom-icon icon-policy-download"
                :loading="downloadTemplateLoading"
                @click="handleDownloadTemplate"
                >模板下载</el-button
              >
              <el-upload
                ref="uploadRef"
                action="#"
                :auto-upload="false"
                :show-file-list="false"
                :on-change="handleImportFile"
                accept=".xls,.xlsx"
                class="import-upload"
              >
                <el-button plain type="info" icon="el-icon-fake custom-icon icon-policy-insert" :loading="importLoading"
                  >批量导入</el-button
                >
              </el-upload>
            </div> -->
          </div>
        </template>
        <template slot="operate" slot-scope="scope" width="300">
          <el-button @click="handleView(scope.row)" size="small" type="text">查看</el-button>
          <el-button
           v-if="Number(scope.row.status) === 2"
           @click="handleEdit(scope.row)" size="small" type="text">编辑</el-button>
          <el-button
            v-if="Number(scope.row.status) === 2"
            @click="handleOnline(scope.row)"
            size="small"
            type="text"
            >上线</el-button
          >
          <el-button
            v-if="Number(scope.row.status) === 1"
            @click="handleOffline(scope.row)"
            size="small"
            type="text"
            >下线</el-button
          >
          <el-button @click="handleViewSignupInfo(scope.row)" size="small" type="text">查看报名信息</el-button>
          <el-button
            v-if="Number(scope.row.status) === 2"
            type="text"
            style="color: rgb(241, 74, 63)"
            size="small"
            @click="handleDel(scope.row)"
            >删除</el-button
          >
        </template>
      </myTableSearch>
      <!-- 新增/编辑/ -->
      <policyDialog
        v-if="isSubscribeDialog"
        :isDialog="isSubscribeDialog"
        :isEdit="isEdit"
        :isView="isView"
        :title-text="policyDialogTitle"
        :editData="editData"
        @handleClose="onPolicyDialogClose"
        @success="handleRefresh"
      >
      </policyDialog>
      <!-- 导入结果 -->
      <importResultDialog
        v-if="isImportResultDialog"
        :isDialog="isImportResultDialog"
        :resultData="importResultData"
        @handleClose="isImportResultDialog = false"
      >
      </importResultDialog>
    </div>
  </div>
</template>

<script>
import "@/assets/css/base.css";
import {
  getTrainingClassSignupInfoList,
  getTrainingInstitutionRelated,
  getTrainingClassSignupInfoOnline,
  getTrainingClassSignupInfoOffline,
  deleteTrainingClassSignupInfo,
  downloadTemplate,
  importOrganization,
} from "@/api/training";
import policyDialog from "./components/policyDialog.vue";
import importResultDialog from "./components/importResultDialog.vue";
import refreshIcon from "@/assets/pages/appointment/refresh.png";

export default {
  name: "PolicyList",
  components: {
    policyDialog,
    importResultDialog,
  },
  data() {
    return {
      refreshIcon,
      currentPage: 1,
      downloadTemplateLoading: false,
      importLoading: false,
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        pageSizes: [10, 20, 50],
      },
      isSubscribeDialog: false, // 新增 / 编辑 / 查看活动弹窗
      isEdit: false,
      isView: false,
      editData: {},
      policyDialogTitle: "",
      isImportResultDialog: false, //导入结果弹窗
      importResultData: "", //导入结果
      formData: [
        {
          label: "活动名称",
          type: "input",
          key: "name",
          colLg: 6,
          placeholder: "活动名称",
        },
        {
          label: "项目名称",
          type: "input",
          key: "projectName",
          colLg: 6,
          placeholder: "项目名称",
        },
        {
          label: "关联机构",
          type: "select",
          key: "institutionId",
          colLg: 6,
          placeholder: "关联机构",
          filterable: true,
          data: [],
        },
        {
          label: "状态",
          type: "select",
          key: "status",
          colLg: 6,
          placeholder: "状态",
          data: [
            { dictLabel: "全部", dictValue: "" },
            { dictLabel: "在线", dictValue: 1 },
            { dictLabel: "下线", dictValue: 2 },
          ],
        },
        {
          label: "创建时间",
          type: "daterange",
          key: "createTimeRange",
          colLg: 8,
          placeholder: "创建时间",
          screen(val) {
            if (!val || !Array.isArray(val) || val.length < 2) {
              return {};
            }
            return {
              createTimeStart: val[0] || "",
              createTimeEnd: val[1] || "",
            };
          },
        },
      ],
      tableLabel: [
        {
          prop: "name",
          label: "活动名称",
          width: 180,
          minWidth: 120,
        },
        {
          prop: "institutionName",
          label: "关联机构",
          width: 200,
          minWidth: 140,
        },
        {
          prop: "projectName",
          label: "关联培训项目",
          width: 200,
          minWidth: 140,
        },
        {
          prop: "openClassTimeList",
          label: "开班时间配置",
          width: 220,
          minWidth: 160,
          isTooltip: true,
        },
        {
          prop: "status",
          label: "状态",
          width: 100,
          align: "center",
        },
        {
          prop: "createTime",
          label: "创建时间",
          width: 180,
          minWidth: 160,
        },
      ],
    };
  },
  mounted() {
    this.loadSearchFilterOptions();
  },
  methods: {
    pickResponseRows(res) {
      const d = res && res.data;
      if (Array.isArray(d)) return d;
      if (d && Array.isArray(d.rows)) return d.rows;
      if (d && Array.isArray(d.list)) return d.list;
      if (d && Array.isArray(d.records)) return d.records;
      return [];
    },
    mapRowsToDictOptions(rows, labelPick, valuePick) {
      const list = Array.isArray(rows) ? rows : [];
      const all = { dictLabel: "全部", dictValue: "" };
      const rest = list.map((row) => ({
        dictLabel: labelPick(row),
        dictValue: valuePick(row),
      }));
      return [all, ...rest];
    },
    async loadSearchFilterOptions() {
      const listQuery = { pageNum: 1, pageSize: 9999 };
      try {
        const [instRes] = await Promise.all([getTrainingInstitutionRelated(listQuery)]);
        const instRows = instRes && instRes.code === 200 ? this.pickResponseRows(instRes) : [];
        const instIdx = this.formData.findIndex((i) => i.key === "institutionId");
        if (instIdx !== -1) {
          this.$set(
            this.formData[instIdx],
            "data",
            this.mapRowsToDictOptions(
              instRows,
              (r) => r.name || r.institutionName || r.cultivateInstitutionName || r.unitName || "-",
              (r) => (r.id != null ? r.id : r.institutionId ?? r.cultivateInstitutionId ?? ""),
            ),
          );
        }
      } catch (e) {
        console.error("加载筛选项失败", e);
      }
    },
    buildSignupListQuery(raw) {
      const q = raw || {};
      let status = "";
      if (q.status !== undefined && q.status !== null && q.status !== "") {
        const n = Number(q.status);
        if (!Number.isNaN(n)) status = n;
      }
      return {
        name: q.name != null && String(q.name).trim() !== "" ? String(q.name).trim() : "",
        projectName: q.projectName != null && String(q.projectName).trim() !== "" ? String(q.projectName).trim() : "",
        institutionId: q.institutionId != null && q.institutionId !== "" ? q.institutionId : "",
        status,
        createTimeStart:
          q.createTimeStart != null && q.createTimeStart !== "" ? String(q.createTimeStart).split(" ")[0] : "",
        createTimeEnd: q.createTimeEnd != null && q.createTimeEnd !== "" ? String(q.createTimeEnd).split(" ")[0] : "",
      };
    },
    // 获取列表数据（myTableSearch 已组装 queryParams.query）
    queryFn(queryParams) {
      const payload = {
        pageNum: queryParams.pageNum,
        pageSize: queryParams.pageSize,
        query: this.buildSignupListQuery(queryParams.query),
      };
      return getTrainingClassSignupInfoList(payload);
    },
    activityRowId(row) {
      return row.activityId != null && row.activityId !== "" ? row.activityId : row.id;
    },
    formatOpenClassTimeList(row) {
      const v = row && row.openClassTimeList;
      if (v == null || v === "") return "-";
      if (Array.isArray(v)) {
        const s = v.map((x) => (x != null ? String(x) : "")).filter(Boolean);
        return s.length ? s.join("、") : "-";
      }
      if (typeof v === "string") {
        try {
          const parsed = JSON.parse(v);
          if (Array.isArray(parsed)) {
            return parsed.length ? parsed.join("、") : "-";
          }
        } catch (e) {
          /* 非 JSON 则原样展示 */
        }
        return v || "-";
      }
      return "-";
    },
    handleOnline(row) {
      if (Number(row.status) !== 2) {
        this.$message.warning("仅下线的活动可以上线");
        return;
      }
      const id = this.activityRowId(row);
      if (id === undefined || id === null || id === "") {
        this.$message.warning("无法获取活动 ID");
        return;
      }
      this.$confirm("确定要上线该活动吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          getTrainingClassSignupInfoOnline(id)
            .then((res) => {
              if (res && res.code === 200) {
                this.$message.success("上线成功");
                this.handleRefresh();
              } else {
                this.$message.error((res && res.msg) || "上线失败");
              }
            })
            .catch((err) => {
              console.error(err);
              this.$message.error("上线失败");
            });
        })
        .catch(() => {});
    },
    handleOffline(row) {
      if (Number(row.status) !== 1) {
        this.$message.warning("仅在线的活动可以下线");
        return;
      }
      const id = this.activityRowId(row);
      if (id === undefined || id === null || id === "") {
        this.$message.warning("无法获取活动 ID");
        return;
      }
      this.$confirm("确定要下线该活动吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          getTrainingClassSignupInfoOffline(id)
            .then((res) => {
              if (res && res.code === 200) {
                this.$message.success("下线成功");
                this.handleRefresh();
              } else {
                this.$message.error((res && res.msg) || "下线失败");
              }
            })
            .catch((err) => {
              console.error(err);
              this.$message.error("下线失败");
            });
        })
        .catch(() => {});
    },
    handleViewSignupInfo(row) {
      const id = this.activityRowId(row);
      if (id === undefined || id === null || id === "") {
        this.$message.warning("无法获取活动 ID");
        return;
      }
      this.$router.push({
        path: "/employment/training/organization/info",
        query: { id: String(id) },
      });
    },
    // 上一页
    handlePrevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
        this.queryParams.pageNum = this.currentPage;
        this.$refs.tableRef && this.$refs.tableRef.handleSearch();
      }
    },
    // 下一页
    handleNextPage() {
      this.currentPage++;
      this.queryParams.pageNum = this.currentPage;
      this.$refs.tableRef && this.$refs.tableRef.handleSearch();
    },
    // 刷新列表
    handleRefresh() {
      this.queryParams.pageNum = 1;
      this.currentPage = 1;
      this.$refs.tableRef && this.$refs.tableRef.handleSearch();
    },
    // 删除
    handleBatchDelete() {
      this.$refs.tableRef && this.$refs.tableRef.deleteAll();
    },
    // 下载导入模板
    handleDownloadTemplate() {
      this.downloadTemplateLoading = true;
      downloadTemplate({})
        .then((res) => {
          if (res) {
            this.downloadBlobFile(res, "机构导入模板.xls");
          }
        })
        .catch((err) => {
          console.error("下载失败", err);
          this.$message.error("下载失败");
        })
        .finally(() => {
          this.downloadTemplateLoading = false;
        });
    },
    // 导入文件
    handleImportFile(file) {
      const isExcel =
        file.raw.type === "application/vnd.ms-excel" ||
        file.raw.type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
      const isLt10M = file.raw.size / 1024 / 1024 < 10;

      if (!isExcel) {
        this.$message.error("只能上传 .xls 或 .xlsx 格式的文件！");
        return;
      }
      if (!isLt10M) {
        this.$message.error("文件大小不能超过 10MB！");
        return;
      }

      this.importLoading = true;
      const formData = new FormData();
      formData.append("file", file.raw);

      importOrganization(formData)
        .then((res) => {
          if (res && res.code === 200) {
            this.importResultData = res.data;
            this.isImportResultDialog = true;
            this.handleRefresh();
          } else {
            this.$message.error(res.msg || "导入失败");
          }
        })
        .catch((err) => {
          console.error("导入出错", err);
          this.$message.error("导入失败");
        })
        .finally(() => {
          this.importLoading = false;
          this.$refs.uploadRef && this.$refs.uploadRef.clearFiles();
        });
    },
    onPolicyDialogClose() {
      this.isSubscribeDialog = false;
      this.isView = false;
      this.policyDialogTitle = "";
    },
    // 新增活动
    handleAddAppointment() {
      this.isEdit = false;
      this.isView = false;
      this.policyDialogTitle = "";
      this.editData = {};
      this.isSubscribeDialog = true;
    },
    // 查看活动（与编辑共用 policyDialog）
    handleView(row) {
      this.isView = true;
      this.isEdit = false;
      this.editData = { ...row };
      this.policyDialogTitle = row.name ? `查看活动 — ${row.name}` : "查看活动";
      this.isSubscribeDialog = true;
    },
    // 编辑活动
    handleEdit(row) {
      this.isEdit = true;
      this.isView = false;
      this.editData = { ...row };
      this.policyDialogTitle = row.name ? `编辑活动 — ${row.name}` : "编辑活动";
      this.isSubscribeDialog = true;
    },
    // 删除活动（仅下线 status === 2 可删）
    handleDel(row) {
      if (Number(row.status) !== 2) {
        this.$message.warning("仅下线的活动可以删除");
        return;
      }
      const id = this.activityRowId(row);
      if (id === undefined || id === null || id === "") {
        this.$message.warning("无法获取活动 ID");
        return;
      }
      this.$confirm("确定要删除该活动吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          deleteTrainingClassSignupInfo(id)
            .then((res) => {
              if (res && res.code === 200) {
                this.$message.success("删除成功");
                this.handleRefresh();
              } else {
                this.$message.error((res && res.msg) || "删除失败");
              }
            })
            .catch((err) => {
              console.error("删除失败", err);
              this.$message.error("删除失败");
            });
        })
        .catch(() => {});
    },
    // 更新总数
    successQuery(e) {
      this.syrkNum = e.total;
    },
  },
};
</script>

<style lang="scss" scoped>
.content {
  width: 100%;
  height: 100%;
  background: #fff;
  display: flex;
  flex-direction: column;

  &-select {
    height: 50px;
    .select-title {
      height: 46px;
      background: url("~@/assets/appraisal/selectBg.png") no-repeat;
      background-size: 100% 100%;
      display: flex;
      align-items: center;
      gap: 12px;
      padding-left: 16px;
      .title-img {
        width: 18px;
        height: 18px;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .title-info {
        color: var(--vt-c-black-mute-soft);
        font-size: 16px;
        font-weight: 700;
      }
    }
    .select-serch {
      margin-top: 12px;
      display: flex;
      align-items: center;
      gap: 8px;
      .serch-hint {
        color: var(--vt-c-black-mute-soft);
        font-size: 14px;
        font-weight: 400;
      }
      .serch-info {
        height: 28px;
        display: flex;
        align-items: center;
        gap: 12px;
        .info-item {
          width: 120px;
          height: 28px;
          text-align: center;
          line-height: 28px;
          background: var(--vt-c-blue-mute);
          color: var(--vt-c-blue);
          border-radius: 2px;
          cursor: pointer;
          transition: all 0.3s ease;

          &:hover {
            opacity: 0.8;
          }

          &.active {
            background: var(--vt-c-blue);
            color: var(--vt-c-white);
          }

          &:active:not(.active) {
            transform: scale(0.98);
          }
        }
      }
    }
  }
  &-header {
    padding: 0 24px;
    overflow: hidden;
    display: flex;
    flex-direction: column;

    /deep/.myTableSearch {
      padding: 0;
      height: 740px;
      display: flex;
      flex-direction: column;

      /deep/.el-table {
        flex: 1;
        overflow: auto;
      }
    }
  }
}

.link-text {
  color: #409eff;
  text-decoration: none;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
}

.toolbar-container {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 0;

  .toolbar-icon {
    width: 24px;
    height: 24px;
  }

  .add-icon {
    width: 20px;
    height: 20px;
    margin-right: 6px;
  }

  .toolbar-left {
    display: flex;
    align-items: center;
    gap: 12px;
    .tool-btn {
      width: 36px;
      height: 36px;
      display: flex;
      align-items: center;
      justify-content: center;
      border: 1px solid #dcdfe6;
      cursor: pointer;
      transition: all 0.2s;
      background-color: #fcfcfcff;
    }
    .list-title {
      font-size: 14px;
      font-weight: 400;
      color: var(--vt-c-blue-soft);
    }
  }

  .toolbar-right {
    display: flex;
    align-items: center;
    gap: 12px;

    .import-upload {
      display: inline-block;

      /deep/.el-upload {
        display: inline-block;
      }
    }

    .el-button {
      height: 36px;
      padding: 0 16px;
    }
  }
}

.status-tag {
  border-radius: 14px;
  padding: 0 12px;
  font-weight: 500;
  border: none;
}

.cell-ellipsis {
  display: inline-block;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  vertical-align: middle;
}
</style>
